// Mismo reparto que hace el backend con los tours privados (por vehículo): pesos enteros, el resto
// va a los primeros pasajeros, así la suma da exacto el total.
export default function repartir(total: number, n: number): number[] {
    if (n <= 0) return []
    const entero = Math.round(Number(total) || 0)
    const base = Math.floor(entero / n)
    const resto = entero - base * n
    return Array.from({ length: n }, (_, i) => base + (i < resto ? 1 : 0))
}
